import React, { Component } from 'react';
import { Card, CardImg, CardText, CardBody, CardFooter, CardHeader } from 'reactstrap';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import InsigniaResultCard from './InsigniaResultCard';
import { AppContext } from '../AppContext';

const colors = ['#FFFFFF', '#354750', '#F48700', '#A72186', '#1DA656', '#EA3B13', '#1F58AB']

const nombre = 'Kleber Enrique';

const texto = `En este sistema podr�s visualizar tus actividades extracurriculares en la ESPOL, incluyendo clubes, competencias, logros en deportes, cultura entre otros. Adem�s, podr�s descargarte certificados de tus actividades extracurriculares que podr�an ayudarte en procesos de selecci�n laboral personal o en aplicaci�n a programas de postgrados. Se actualizar� constantemente y se pueden incluir actividades de otras instituciones para validarlas. Tambi�n se pueden visualizar insignias digitales obtenidas por destacar en actividades extracurriculares.

Si tienes dudas nos puedes contactar a acompanamiento@espol.edu.ec`;

export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = {
            userId: 0,
            nombres: ''
        };
    }

    componentDidMount() {
        let user = this.context;
        if (user != null) {            
            this.setState({ userId: user.idpersona, nombres: user.nombres });
            //console.log(this.state);
        }
    }

    componentDidUpdate() {
        let user = this.context;
        if (user != null && this.state.iduser == 0) {            
            this.setState({ userId: user.idpersona, nombres: user.nombres });
            //console.log(this.state);
        }
    }

    titulo(name) {
        let lowerCaseName = name.toLowerCase();
        let newName = lowerCaseName.split(" ");        
        return newName[0].charAt(0).toUpperCase() + newName[0].slice(1) + " " + newName[1].charAt(0).toUpperCase() + newName[1].slice(1);
    }

    render() {        
        const currentUser = this.context;
        return (
            <div style={{ textAlign: 'justify' }}>
              {currentUser && currentUser.idpersona > 0 ? <h1>&iexcl;Hola {this.titulo(currentUser.nombres)}!</h1> : <h1>&iexcl;Hola!</h1>}
                En este sistema podr&aacute;s visualizar tus actividades extracurriculares en la ESPOL, incluyendo clubes, competencias, logros en deportes, cultura entre otros. Adem&aacute;s, podr&aacute;s descargarte certificados de tus actividades extracurriculares que podr&iacute;an ayudarte en procesos de selecci&oacute;n laboral personal o en aplicaci&oacute;n a programas de postgrados. Se actualizar&aacute; constantemente y se pueden incluir actividades de otras instituciones para validarlas. Tambi&eacute;n se pueden visualizar insignias digitales obtenidas por destacar en actividades extracurriculares.
                <br/><br/>
                <strong>Si tienes dudas nos puedes contactar a <a href='mailto:acompanamiento@espol.edu.ec'>acompanamiento@espol.edu.ec</a></strong>

              <br />
              
              <br />
        </div>
          
    );
  }
}
Home.contextType = AppContext;
